module.exports = __webpack_public_path__ + "static/media/abtus1.b8e12f3a.svg";